import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild, computed, signal } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { DialogService } from 'src/app/core/services/dialog.service';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';
import { DatiControlloRowTemplateComponent } from '../components/dati-controllo-row-template/dati-controllo-row-template.component';
import { PageComponent } from 'src/app/layout/pages/page/page.component';
import { ControlliService } from '../controlli.service';
import { EmptyListComponent } from 'src/app/shared/components/error/empty-list/empty-list.component';
import { PrelievoFormComponent } from '../components/prelievo-form/prelievo-form.component';
import { AnalisiFormComponent } from '../components/analisi-form/analisi-form.component';
import { ParametriService } from '../../parametri/parametri.service';
import { PuntiCampionamentoService } from '../../punti-campionamento/punti-campionamento.service';
import { InputSelectComponent } from 'src/app/shared/components/inputs/input-select/input-select.component';
import { PoiSearchSelectComponent } from '../../punti-campionamento/components/search-select/search-select.component';
import { IParametroControllato } from '../models/dati-controllo.model';
import { PuntiCampionamentoControlliInputSelectComponent } from '../components/punti-campionamento-controlli-input-select/punti-campionamento-controlli-input-select.component';
import { CardComponent } from 'src/app/shared/components/cards/card/card.component';
import { InputToggleComponent } from 'src/app/shared/components/inputs/input-toggle/input-toggle.component';
import { IPuntoCampionamento } from '../../punti-campionamento/punti-campionamento.model';

@Component({
  selector: 'app-invio-dati-page',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatStepperModule,
    PageComponent,
    InputTextComponent,
    InputToggleComponent,
    InputSelectComponent,
    MyButtonComponent,
    PrelievoFormComponent,
    AnalisiFormComponent,
    DatiControlloRowTemplateComponent,
    EmptyListComponent,
    PuntiCampionamentoControlliInputSelectComponent,
    CardComponent
  ],
  templateUrl: './invio-dati-page.component.html',
  styleUrl: './invio-dati-page.component.css',
  changeDetection: ChangeDetectionStrategy.Default,
})

export class InvioDatiPageComponent implements OnInit {
  @ViewChild('pageStepper') private pageStepper?: MatStepper;
  stepCount = signal(0);
  selectedStepIndex = signal(0);
  canGoNextStep = computed(() => (this.selectedStepIndex() < this.stepCount() - 1));
  canGoPreviousStep = computed(() => this.selectedStepIndex() > 0);
  canShowSend = computed(() => (this.selectedStepIndex() === this.stepCount() - 1))
  prelievoForm: FormGroup;
  controlliForm: FormGroup;
  newElement: FormGroup;
  parametri = this.parametriService.list;
  poiSearchComponent = PoiSearchSelectComponent;
  poi = this.service.query.list;
  puntiCampDateValid?:IPuntoCampionamento;

  constructor(
    private readonly fb: FormBuilder,
    private readonly controlliService: ControlliService,
    private readonly parametriService: ParametriService,
    public readonly service: PuntiCampionamentoService,
    private dialogService: DialogService,
  ) {
    this.prelievoForm = this.fb.group({
      uuid: new FormControl('', [Validators.required]),
      controlloEsterno: new FormControl(false, [Validators.required]),
      controlloExtraPiano: new FormControl(false, [Validators.required]),
      prelievo: this.fb.group({}),
      analisi: this.fb.group({}),
    });
    this.controlliForm = this.fb.group({
      controlli: this.fb.array<IParametroControllato>([])
    })
    const decimalPlaces: number = 3;
    const decimalRegex = new RegExp(`^\\d*\\.?\\d{0,${decimalPlaces}}$`);
    this.newElement = new FormGroup({
      parametroId: new FormControl(null, [Validators.required]),
      valoreRapportoProva: new FormControl(null, {
        //validators: [Validators.required, Validators.pattern(decimalRegex)],
        updateOn: 'blur'
      }),
      valoreArrotondato: new FormControl(null, {
       // validators: [Validators.required],
        updateOn: 'blur'
      }),
      incertezza: new FormControl(null, {
        //validators: [Validators.required, Validators.pattern(decimalRegex)],
        updateOn: 'blur'
      }),
      metodo: new FormControl(null, {
        //validators: [Validators.required, Validators.pattern(decimalRegex)],
        updateOn: 'blur'
      }),
      valoreLoq: new FormControl(null, {
        //validators: [Validators.required, Validators.pattern(decimalRegex)],
        updateOn: 'blur'
      }),
      valoreLfs: new FormControl(null, {
        //validators: [Validators.required, Validators.pattern(decimalRegex)],
        updateOn: 'blur'
      }),
      loq: new FormControl(null, {
        //validators: [Validators.required, Validators.pattern(decimalRegex)],
        updateOn: 'blur'
      }),
      lfs: new FormControl(null, {
        //validators: [Validators.required, Validators.pattern(decimalRegex)],
        updateOn: 'blur'
      }),
    });
    this.newElement.get('valoreRapportoProva')?.valueChanges.subscribe((value) => {
      if (this.newElement.get('valoreRapportoProva')?.valid) {
       // const formattedValue = parseFloat(value).toFixed(decimalPlaces);
       const formattedValue = value
        if (this.newElement.get('valoreRapportoProva')?.value !== formattedValue) {
          this.newElement.get('valoreRapportoProva')?.setValue(formattedValue);
        }
      }
    })
    
  }

  ngOnInit(): void {
    this.getParametri();
    //this.getPoi();
  }

  ngAfterViewInit() {
    if (this.pageStepper) {
      this.stepCount.set(this.pageStepper.steps.length);
    }
  }

  trackByIndex = (index: number): number => {
    return index;
  };

  get prelievo(): FormGroup {
    return this.prelievoForm.get('prelievo') as FormGroup;
  }

  get analisi(): FormGroup {
    return this.prelievoForm.get('analisi') as FormGroup;
  }

  get controlli(): FormArray {
    return this.controlliForm.get('controlli') as FormArray;
  }

  toFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  onDeleteClick(element: IParametroControllato, index: number) {
    this.dialogService.confirm('Elimina', `Il parametro ${element.name} sarà eliminato dalla lista dei controlli senza possibilità di recupero.`, {
      label: 'Elimina',
      color: 'warn',
      icon: 'delete',
      raised: true
    }).subscribe((result) => {
      if (result === true) {
        //delete
        this.controlli.removeAt(index, {emitEvent: true});
      }
    })
  }

  onDeleteAllClick() {
    if (this.canDeleteAll) {
      this.dialogService.confirm('Elimina TUTTI', `I ${this.controlli.length} controlli presenti saranno eliminati senza possibilità di recupero.`, {
        label: 'Elimina',
        color: 'warn',
        icon: 'delete',
        raised: true
      }).subscribe((result) => {
        if (result === true) {
          //delete
          this.controlli.clear();
        }
      })
    }
  }

  onAddClick() {
    if (this.newElement.valid) {
      this.controlli.push(new FormGroup({
        parametroId: new FormControl(this.newElement.value['parametroId'], [Validators.required]),
        valoreRapportoProva: new FormControl(this.newElement.value['valoreRapportoProva']),
        valoreArrotondato: new FormControl(this.newElement.value['valoreArrotondato']),
        incertezza: new FormControl(this.newElement.value['incertezza']),
        metodo: new FormControl(this.newElement.value['metodo']),
        valoreLoq: new FormControl(this.newElement.value['valoreLoq']),
        valoreLfs: new FormControl(this.newElement.value['valoreLfs']),
        lfs: new FormControl(this.newElement.value['lfs']),
        loq: new FormControl(this.newElement.value['loq']),
      }))
      this.newElement.reset();
    }
  }

  onSendClick() {
    if (this.canSend) {
      this.dialogService.confirm('Trasmetti', `Stai per trasmettere ${this.controlli.length} controlli. I dati saranno storicizzati sui server di AnTeA.`, {
        label: 'Conferma',
        color: 'primary',
        icon: 'done',
        raised: true
      }).subscribe((result) => {
        if (result === true) {
          this.controlliService.sendJson({
            ...this.prelievoForm.value,
            dati: this.controlli.value
          }).subscribe((value) => {
            this.sendMessage(value);
            this.resetPage();
          })
        }
      })
    }
  }

  private sendMessage(value: any) {
    let message = `I dati sono stati trasmessi: `;
    message += value.datiOK > 0 ? `${value.datiOK} controlli sono stati salvati. ` : 'nessun controllo è stato salvato. ';
    if (value.datiKO > 0) {
      message += `${value.datiKO} controlli sono stati scartati.`;
      this.dialogService.info(message);
    } else if (value.datiOK > 0) {
      this.dialogService.success(message, true);
    } else {
      this.dialogService.error(`Qualcosa è andato storto: ${value}`);
    }
  }

  private resetPage() {
    this.prelievoForm.reset();
    this.controlli.clear();
    this.controlliForm.reset();
    this.pageStepper?.reset();
  }

  get isValidForm() {
    if (this.selectedStepIndex() === 0) {
      return !this.prelievoForm.invalid;
    } else if (this.selectedStepIndex() === 1) {
      return !this.controlliForm.invalid;
    } else {
      return false;
    }
  };

  get canSend() {
    return (this.prelievoForm.valid && this.controlliForm.valid && this.controlli.length > 0);
  }

  get canDeleteAll() {
    return (this.controlli.length > 0);
  }

  onStepChange(event: any): void {
    this.selectedStepIndex.set(event.selectedIndex)
  }

  nextPageClick() {
    this.pageStepper?.next();
  }

  previousPageClick() {
    this.pageStepper?.previous();
  }

  getParametri() {
    this.parametriService.query.getAll();
  }

  getPoi() {
    this.service.query.getAll();
  }

  chekDataSelectedd(e:any){
    this.controlliService.getDateVal(e.id).subscribe((val:any)=>{this.puntiCampDateValid=val})
  }
}
